import { defineComponent, PropType } from "vue";

import { COMPONENT_NAME, SVG } from "./attributes";

import { DepositWithdrawalHistoryResponse } from "@/shared/repository/modules/deposit-withdrawal/repo";
import { SvgAttribute } from "@/shared/constants/constants";
import { formatFiatCurrency } from "@/shared/utils/amount-helpers";

export default defineComponent({
  name: COMPONENT_NAME,
  props: {
    row: {
      type: <PropType<DepositWithdrawalHistoryResponse>>Object,
      required: true,
    },
  },
  computed: {
    displayedSvg(): SvgAttribute {
      return SVG;
    },

    displayedAmount(): string {
      return formatFiatCurrency(this.row.amount);
    },

    isDeposit(): boolean {
      return this.row.app_type === "deposit";
    },

    currencyName(): string {
      const currency = this.row.currency as unknown;

      if (typeof currency === "string") return currency.toUpperCase();

      return (currency as { name?: string }).name?.toUpperCase() || "";
    },

    statusTone(): string {
      const status = this.row.status;

      if (status === "completed") return "success";
      if (status === "reject" || status === "failed") return "error";
      if (status === "waiting" || status === "in_work") return "warning";

      return "pending";
    },

    statusLabel(): string {
      const labels: Record<string, string> = {
        completed: "Успешно",
        reject: "Отклонено",
        failed: "Отклонено",
        waiting: "Ожидает оплаты",
        in_work: "В обработке",
        pending: "На проверке",
      };

      return labels[this.row.status] || "На проверке";
    },
  },
});
